function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 22,
  height: 22
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icon/action/delete/white",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Background"
}), /*#__PURE__*/React.createElement("line", {
  x1: 9,
  y1: 9,
  x2: 9,
  y2: 18,
  id: "Stroke-1",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeLinecap: "round",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("line", {
  x1: 13,
  y1: 9,
  x2: 13,
  y2: 18,
  id: "Stroke-2",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeLinecap: "round",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  mask: "url(#mask-2)",
  stroke: "#FFFFFF",
  strokeLinecap: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-3",
  strokeLinejoin: "round",
  points: "2 5 4 20 16 20 18 5"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 4,
  x2: 20,
  y2: 4,
  id: "Stroke-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13,3 C13,1.343 11.657,0 10,0 C8.343,0 7,1.343 7,3",
  id: "Stroke-7"
}))));

function SvgWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.144118ff.svg";
export { ForwardRef as ReactComponent };